module.exports = __webpack_public_path__ + "img/mobile_girl_four.e73e0254.png";